import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ExternalLink } from 'lucide-react';
import SEO from '../components/SEO';
import MediaTruthSurface from '../components/MediaTruthSurface';
import { MEDIA_SLOTS } from '../lib/mediaTruth';
import './ClubPages.css';

const partnerships = [
  {
    name: 'Devil Mountain Cornhole',
    text: 'Community cornhole events use Scoreholio for registration, with weekly events open to members and non-members. Contact John at (925) 234-2832 for information.',
  },
  {
    name: 'East County Shred Mountain Biking Team',
    text: 'Delta Valley provides an indoor winter practice space for local youth mountain bikers and their coaches.',
    href: 'https://www.instagram.com/eastcountyshred/',
  },
  {
    name: "Sara's Aesthetics",
    text: 'This partnership helps the community access skincare and aesthetic services alongside their wellness routine.',
    href: 'https://www.instagram.com/aestheticswith.sara/',
  },
  {
    name: 'Brentwood PAL',
    text: 'Youth academy leaders and police officers use the basketball court for exercise and relationship-building activities.',
    href: 'https://www.instagram.com/brentwood_pal/',
  },
  {
    name: 'Working Wonders',
    text: 'Delta Valley welcomes adults with disabilities for movement and community activities on the basketball courts.',
    href: 'https://www.letsworkwonders.org/',
  },
  {
    name: 'CISS',
    text: 'Community Integrated Support Services clients use the club for physical activity, well-being, and social connection.',
    href: 'https://www.cissinc.org/',
  },
  {
    name: 'Chosen Training Organization',
    text: 'Delta Valley supports local athletes as they develop sportsmanship, academic achievement, character, and basketball skills.',
  },
];

const PartnershipsPage = () => (
  <main className="dv-club-pages" data-testid="partnerships-page">
    <SEO
      title="Community Partnerships"
      description="See how Delta Valley Health Club works with schools, nonprofits, law enforcement, small businesses, and youth organizations in our community."
      keywords="Delta Valley community partnerships, Brentwood community gym, Brentwood partnerships"
    />
    <section className="dv-club-pages__hero" aria-labelledby="partnerships-title">
      <div className="dv-club-pages__hero-inner dv-club-pages__hero-inner--split">
        <div>
          <h1 id="partnerships-title" className="dv-size-heading text-4xl md:text-6xl font-bold mb-6">Community Partnerships</h1>
          <p className="dv-size-lede text-xl">We are more than a family-run business—we are deeply connected to the people and organizations that make our neighborhoods stronger.</p>
        </div>
        <MediaTruthSurface media={MEDIA_SLOTS.partnershipsHero} className="dv-club-pages__hold" />
      </div>
    </section>
    <nav className="dv-club-pages__navigation" aria-label="Club story and community">
      <Link to={publicHref("/about-us")}>Our Story</Link>
      <Link to={publicHref("/partnerships")} aria-current="page">Community Partnerships</Link>
    </nav>
    <section className="dv-club-pages__partnerships" aria-label="Community organizations">
      {partnerships.map(({ name, text, href }, index) => (
        <article key={name} className="dv-club-pages__partner" aria-labelledby={`partner-${index}`}>
          <span className="dv-club-pages__index" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
          <h2 id={`partner-${index}`} className="dv-size-subheading text-xl font-bold">{name}</h2>
          <div>
            <p className="dv-size-body leading-relaxed">{text}</p>
            {href && <a href={publicHref(href)} target="_blank" rel="noopener noreferrer" aria-label={`Learn more about ${name} (opens in a new tab)`} className="dv-club-pages__partner-link inline-flex items-center gap-1 font-semibold hover:underline">Learn more <ExternalLink size={15} /></a>}
          </div>
        </article>
      ))}
    </section>
    <section className="dv-club-pages__closing" aria-labelledby="partner-contact-title">
      <div className="dv-club-pages__closing-inner">
        <div>
          <h2 id="partner-contact-title" className="dv-size-heading text-3xl font-bold mb-4">Interested in Partnering With Delta Valley?</h2>
          <p className="dv-size-lede text-lg">Tell us about your organization and how we can support our community together.</p>
        </div>
        <div className="dv-club-pages__actions">
          <Button asChild size="lg" variant="secondary" className="dv-club-pages__primary"><Link to={publicHref("/book-a-tour")}>Book a Tour</Link></Button>
          <Button asChild size="lg" variant="outline" className="dv-club-pages__secondary"><Link to={publicHref("/contact")}>Contact Our Team</Link></Button>
        </div>
      </div>
    </section>
  </main>
);

export default PartnershipsPage;
